

























import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { api as deskApi } from "../store/modules/desk";
@Component({})
export default class DoKoBockInfo extends Vue {
  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  @Getter(deskApi.getters.getRamCount, { namespace: deskApi.namespace })
  ramCount!: number;

  get ramFactor() {
    return Math.pow(2, this.ramCount);
  }

  get transformText() {
    return `translate(${this.x} ${this.y})`;
  }
}
